import i18n from '../i18n'

// in miliseconds
const units = {
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000
}

function relativeDateStringDays(daysDiff) {
  return i18n.$ngettext('%{count} day left', '%{count} days left', daysDiff, { count: daysDiff })
}

function relativeDateStringHours(hoursDiff) {
  return i18n.$ngettext('%{count} hour left', '%{count} hours left', hoursDiff, { count: hoursDiff })
}

function relativeDateStringMinutes(minutesDiff) {
  return i18n.$ngettext('%{count} minute left', '%{count} minutes left', minutesDiff, { count: minutesDiff })
}

function relativeDateStringSeconds(secondsDiff) {
  const count = secondsDiff < 1 ? 0 : secondsDiff
  return i18n.$ngettext('%{count} second left', '%{count} seconds left', count, { count })
}

export default function countdownDate(date, now = new Date()) {
  const diff = date - now

  if (diff >= units.day) {
    return relativeDateStringDays(Math.round(diff / units.day))
  } else if (diff >= units.hour) {
    return relativeDateStringHours(Math.round(diff / units.hour))
  } else if (diff >= units.minute) {
    return relativeDateStringMinutes(Math.round(diff / units.minute))
  } else {
    return relativeDateStringSeconds(Math.round(diff / units.second))
  }
}
